import { IconButton, Box } from '@mui/material'
import CustomButton from 'components/buttons/CustomButton/CustomButton'
import CustomText from 'components/common/CustomText/CustomText'
import CustomDialog from 'components/dialogs/CustomDialog'
import { useAuth } from 'context/AuthContext'
import { useUsersContext } from 'context/UsersContext'
import { useRevokeUser } from 'hooks/useUsers'
import RevokeUserIcon from 'icons/RevokeUserIcon'
import React, { useState } from 'react'
import { snackbarService } from 'services/snackbarService'
import { colors } from 'styles/colors'
import useGlobalStyles from 'styles/globalStyles'

interface Props {
  userId: number;
  userName: string;
}

export default function RevokeUserButton({ userId, userName }: Props) {
  const { user } = useAuth();
  const globalStyles = useGlobalStyles();
  const [open, setOpen] = useState<boolean>(false);
  const { refetch } = useUsersContext();

  const { mutate: revokeMutation, isLoading } = useRevokeUser(
    (data: any) => {
      setOpen(false);
      snackbarService.showSnackbar('User access has been revoked successfully', 'success');
      refetch();
    },
    (err: any) => console.log('err', err),
  )

  const revokeUser = async () => {
    revokeMutation({
      userId: user.id,
      endUserId: userId,
    });
  }

  const handlePress = () => {
    setOpen(true);
  }

  return (
    <>
      <IconButton className={globalStyles.popoverButtonContainer} onClick={handlePress}>
        <Box className={globalStyles.popoverIconContainer}>
          <RevokeUserIcon size={18} />
        </Box>
        <CustomText text="Revoke" ml="5px" color={colors.black} />
      </IconButton>

      <CustomDialog
        open={open}
        title={'Revoke User'}
        message={`Are you sure you want to revoke ${userName}'s access to your dashboard?`}
        alignText='left'
        buttons={[
          <CustomButton
            key='cancel'
            variant='outlined'
            text='Cancel'
            onClick={() => setOpen(false)}
            disabled={isLoading}
            height={35}
          />,
          <CustomButton
            key='delete'
            variant='filled'
            color='error'
            text='Revoke'
            onClick={revokeUser}
            loading={isLoading}
            height={35}
          />,
        ]}
        onClose={() => setOpen(false)}
      />
    </>
  )
}
